import {
  useGraduationYearsHot,
  useInfiniteRecruitmentList,
  useInfiniteRecruitmentListForTop,
} from '../../../core/repositories/recruitingInfoRepository';

export const useRecruitments = () => {
  const {data: graduationYearsHots, isLoading: isLoadingGraduationYearsHot} =
    useGraduationYearsHot({});

  const hotYear = graduationYearsHots?.ok
    ? (graduationYearsHots.value.years.at(-2) ?? undefined)
    : undefined;
  const nextHotYear = graduationYearsHots?.ok
    ? (graduationYearsHots.value.years.at(-1) ?? undefined)
    : undefined;
  // GraduationYearsHots を使って二つの年度対象の募集情報を取得
  const {data, isLoading: isLoadingRecruitments} =
    useInfiniteRecruitmentListForTop({
      queryParams: {
        limit: 100,
        industryCategoryIDs: [],
        order: 'recent',
        tagIDs: [],
        typeIDs: [],
        groupedJobTypeIDs: [],
        page: 1,
        gy: hotYear,
        allgy: 'false',
      },
    });

  const {
    data: nextGraduationYearRecruitments,
    isLoading: isLoadingNextGraduationYearRecruitments,
  } = useInfiniteRecruitmentList({
    queryParams: {
      limit: 10,
      industryCategoryIDs: [],
      order: 'recent',
      tagIDs: [],
      typeIDs: [],
      groupedJobTypeIDs: [],
      page: 1,
      gy: nextHotYear,
      allgy: 'false',
    },
  });

  // 学年不問の募集情報取得
  const {
    data: allGraduationYearRecruitments,
    isLoading: isLoadingAllGraduationYearRecruitments,
  } = useInfiniteRecruitmentList({
    queryParams: {
      limit: 100,
      industryCategoryIDs: [],
      order: 'recent',
      tagIDs: [],
      typeIDs: [],
      groupedJobTypeIDs: [],
      page: 1,
      allgy: 'true',
    },
  });

  const allYearRecruitments =
    allGraduationYearRecruitments?.pages[0]?.recruitments.filter(
      (recruitment) => {
        return recruitment.targetYear === 0;
      },
    );

  const graduationYearRecruitmentsFiltered = graduationYearsHots?.ok
    ? data?.pages[0]?.recruitments.filter((recruitment) => {
        return recruitment.targetYear === hotYear;
      })
    : [];

  const nextGraduationYearRecruitmentsFiltered = graduationYearsHots?.ok
    ? nextGraduationYearRecruitments?.pages[0]?.recruitments.filter(
        (recruitment) => {
          return recruitment.targetYear === nextHotYear;
        },
      )
    : [];

  return {
    graduationYearsHots,
    isLoadingGraduationYearsHot,
    recruitments: data,
    nextGraduationYearRecruitments,
    graduationYearRecruitmentsFiltered,
    nextGraduationYearRecruitmentsFiltered,
    allYearRecruitments,
    isLoadingAllGraduationYearRecruitments,
    isLoadingRecruitments,
    isLoadingNextGraduationYearRecruitments,
  };
};
